import type { HemBenchmark, Situation } from '../types';

const SITUATION_MAP: Record<
  Situation,
  { maritalStatus: string; dependants: number }
> = {
  single_0: { maritalStatus: 'single', dependants: 0 },
  single_1: { maritalStatus: 'single', dependants: 1 },
  couple_0: { maritalStatus: 'married_defacto', dependants: 0 },
  couple_1: { maritalStatus: 'married_defacto', dependants: 1 },
};

export const HEM_BENCHMARKS: HemBenchmark[] = [
  { maritalStatus: 'single', dependants: 0, incomeMin: 0, incomeMax: 50_000, minimumMonthlyExpenseAud: 1_500 },
  { maritalStatus: 'single', dependants: 0, incomeMin: 50_001, incomeMax: 80_000, minimumMonthlyExpenseAud: 1_800 },
  { maritalStatus: 'single', dependants: 0, incomeMin: 80_001, incomeMax: 100_000, minimumMonthlyExpenseAud: 2_100 },
  { maritalStatus: 'single', dependants: 0, incomeMin: 100_001, incomeMax: 150_000, minimumMonthlyExpenseAud: 2_500 },
  { maritalStatus: 'single', dependants: 0, incomeMin: 150_001, incomeMax: 200_000, minimumMonthlyExpenseAud: 3_000 },
  { maritalStatus: 'single', dependants: 0, incomeMin: 200_001, incomeMax: 250_000, minimumMonthlyExpenseAud: 3_600 },
  { maritalStatus: 'single', dependants: 0, incomeMin: 250_001, incomeMax: null, minimumMonthlyExpenseAud: 4_500 },

  { maritalStatus: 'single', dependants: 1, incomeMin: 0, incomeMax: 50_000, minimumMonthlyExpenseAud: 2_100 },
  { maritalStatus: 'single', dependants: 1, incomeMin: 50_001, incomeMax: 80_000, minimumMonthlyExpenseAud: 2_400 },
  { maritalStatus: 'single', dependants: 1, incomeMin: 80_001, incomeMax: 100_000, minimumMonthlyExpenseAud: 2_700 },
  { maritalStatus: 'single', dependants: 1, incomeMin: 100_001, incomeMax: 150_000, minimumMonthlyExpenseAud: 3_100 },
  { maritalStatus: 'single', dependants: 1, incomeMin: 150_001, incomeMax: 200_000, minimumMonthlyExpenseAud: 3_700 },
  { maritalStatus: 'single', dependants: 1, incomeMin: 200_001, incomeMax: 250_000, minimumMonthlyExpenseAud: 4_400 },
  { maritalStatus: 'single', dependants: 1, incomeMin: 250_001, incomeMax: null, minimumMonthlyExpenseAud: 5_500 },

  { maritalStatus: 'married_defacto', dependants: 0, incomeMin: 0, incomeMax: 50_000, minimumMonthlyExpenseAud: 2_500 },
  { maritalStatus: 'married_defacto', dependants: 0, incomeMin: 50_001, incomeMax: 80_000, minimumMonthlyExpenseAud: 2_800 },
  { maritalStatus: 'married_defacto', dependants: 0, incomeMin: 80_001, incomeMax: 100_000, minimumMonthlyExpenseAud: 3_200 },
  { maritalStatus: 'married_defacto', dependants: 0, incomeMin: 100_001, incomeMax: 150_000, minimumMonthlyExpenseAud: 3_700 },
  { maritalStatus: 'married_defacto', dependants: 0, incomeMin: 150_001, incomeMax: 200_000, minimumMonthlyExpenseAud: 4_300 },
  { maritalStatus: 'married_defacto', dependants: 0, incomeMin: 200_001, incomeMax: 250_000, minimumMonthlyExpenseAud: 5_000 },
  { maritalStatus: 'married_defacto', dependants: 0, incomeMin: 250_001, incomeMax: null, minimumMonthlyExpenseAud: 6_000 },

  { maritalStatus: 'married_defacto', dependants: 1, incomeMin: 0, incomeMax: 50_000, minimumMonthlyExpenseAud: 3_100 },
  { maritalStatus: 'married_defacto', dependants: 1, incomeMin: 50_001, incomeMax: 80_000, minimumMonthlyExpenseAud: 3_400 },
  { maritalStatus: 'married_defacto', dependants: 1, incomeMin: 80_001, incomeMax: 100_000, minimumMonthlyExpenseAud: 3_800 },
  { maritalStatus: 'married_defacto', dependants: 1, incomeMin: 100_001, incomeMax: 150_000, minimumMonthlyExpenseAud: 4_400 },
  { maritalStatus: 'married_defacto', dependants: 1, incomeMin: 150_001, incomeMax: 200_000, minimumMonthlyExpenseAud: 5_100 },
  { maritalStatus: 'married_defacto', dependants: 1, incomeMin: 200_001, incomeMax: 250_000, minimumMonthlyExpenseAud: 5_900 },
  { maritalStatus: 'married_defacto', dependants: 1, incomeMin: 250_001, incomeMax: null, minimumMonthlyExpenseAud: 7_000 },
];

export function lookupHem(
  situation: Situation,
  annualIncome: number,
  benchmarks: HemBenchmark[] = HEM_BENCHMARKS,
): number {
  const { maritalStatus, dependants } =
    SITUATION_MAP[situation] ?? SITUATION_MAP.single_0;

  const bands = benchmarks.filter(
    (b) => b.maritalStatus === maritalStatus && b.dependants === dependants,
  );

  for (const b of bands) {
    if (
      annualIncome >= b.incomeMin &&
      (b.incomeMax === null || annualIncome <= b.incomeMax)
    ) {
      return b.minimumMonthlyExpenseAud;
    }
  }

  return bands.length > 0
    ? bands[bands.length - 1].minimumMonthlyExpenseAud
    : 1_500;
}
